<script>
  import { storedSignatureHash, exportContent, exportTitle, exportType, exportSigner, exportDate, storedEditorContent, currentBrowser} from "store";
  import pdfMake from "pdfmake/build/pdfmake";
  import htmlToPdfmake from "html-to-pdfmake";
  import { pdfMakeConceptReportDefinition, pdfMakeInfoSheetDefinition, pdfMakeLogoInfoSheetDefinition, pdfMakePhotoSheetDefinition } from "./pdfmake-definitions";
  import { Button } from "smelte";
  import { pdfMakeFont } from "constants";
  import { format } from "date-fns";
  import { nl } from 'date-fns/locale';
  import { removeSpanFromVars } from 'utils';

  // available types = conceptreport infosheet photosheet
  // export let exportType = 'conceptreport';
  export let info = {};

  export let buttonText = "Genereer / Download PDF";
  function getSignature() {
    return $storedSignatureHash;
  };
  let generateMessageText = "";

  function updateExportContent() {
    let tempval = htmlToPdfmake(removeSpanFromVars($storedEditorContent));
    exportContent.set(
      tempval
    );
  };

  // default filename for conceptreport / infosheet
  function generateFilename() {
    let tempfilename = "";
    switch($exportType) {
      case "conceptreport":
        tempfilename = format(new Date(), 'yyMMdd-HHmmss') + "-verhoor.pdf";
        break;
      case "infosheet":
        tempfilename = format(new Date(), 'yyMMdd-HHmmss') + "-infoblad.pdf";
        break;
      case "photosheet":
        tempfilename = format(new Date(), 'yyMMdd-HHmmss') + "-fotoblad.pdf";
        break;
      case "waiver":
        tempfilename = format(new Date(), 'yyMMdd-HHmmss') + "-afstandsverklaring.pdf";
        break;
      default:
        tempfilename = format(new Date(), 'yyMMdd-HHmmss') + "-pv.pdf";
      }
      return tempfilename;
  };

  function prepareExport() {
    switch($exportType) {
      case "infosheet":
        return pdfMakeInfoSheetDefinition(
          {
            date: format(new Date(), 'eeee dd MMMM yyyy', {locale: nl}),
            title: "ADR Lachgascontrole: "+info.location,
            content: info
          }
        );
        break;
      case "photosheet":
        return pdfMakePhotoSheetDefinition(
          {
            date: format(new Date(), 'eeee dd MMMM yyyy', {locale: nl}),
            title: "Fotoblad: ",
            content: info.meta,
            photos: info.images
          }
        );
        break;
      case "waiver":
        updateExportContent();
        return pdfMakeLogoInfoSheetDefinition(
          {
            date: format(new Date(), 'eeee dd MMMM yyyy', {locale: nl}),
            title: $exportTitle,
            content: $exportContent,
            name: $exportSigner,
            signature: getSignature()
          }
        );
        break;
      case "conceptreport":
      default:
        updateExportContent();
        return pdfMakeConceptReportDefinition(
          {
            date: $exportDate,
            title: $exportTitle,
            content: $exportContent,
            name: $exportSigner,
            signature: getSignature()
          }
        );
        break;
    };
  };


  function exportToPdf() {
    generateMessageText = "PDF genereren...";
    pdfMake.vfs = pdfMakeFont;
    pdfMake.fonts = {
      RobotoMono: {
        normal: 'RobotoMono-Regular.ttf',
        bold: 'RobotoMono-Bold.ttf',
        italics: 'RobotoMono-Italic.ttf',
        bolditalics: 'RobotoMono-BoldItalic.ttf',
        light: 'RobotoMono-Light.ttf',
        lightitalics: 'RobotoMono-LightItalic.ttf'
      }
    };
    let generatedDef = prepareExport();
    if ($currentBrowser === "chromewebview") {
      // pdfMake.createPdf(generatedDef).open();
      // pdfMake.createPdf(generatedDef).download(generateFilename(), null, { bufferPages: false });
      // const myDoc = pdfMake.createPdf(generatedDef); //.getBase64(); doc.getBase64((data) => { window.location.href = 'data:application/pdf;base64,' + data; });

      // myDoc.getBase64((data) => {
      //   window.open('data:application/pdf;base64,' + data;
      // })
      let myDoc = pdfMake.createPdf(generatedDef);
  
      myDoc.getBase64((data) => {
      //    console.log("mec");
      //window.document.body = 'data:application/pdf;base64,' + data; 
        let a = document.createElement("a");
        a.href = "data:application/octet-stream;base64,"+data;
        a.download = "documentName.pdf"
        a.click();
      });  

    } else {
      pdfMake.createPdf(generatedDef).download(generateFilename(), null, { bufferPages: false });
    };
    generateMessageText = "PDF klaar";
  }
  
</script>
  <div class="flex items-center">
    <Button on:click={exportToPdf}>{buttonText}</Button>
    <div class="text-l font-bold ml-2">{generateMessageText}</div>
  </div>
<style>

</style>